import React, { useEffect, useState, useRef } from 'react';
import { SET_DROPDOWN_MENU_ITEMS_LIST, SET_DATA_BY_DAY, UPDATE_DATA_BY_DAY } from "../../actions/types";
import { useSelector, useDispatch } from 'react-redux';
import { ConfirmDialog, WarnDialog } from "../../components/shared";
import 'date-fns';
import DateFnsUtils from '@date-io/date-fns';
import format from 'date-fns/format';
import startOfToday from 'date-fns/startOfToday'
import {
    Backdrop, Button, Box, Card, CardContent, CircularProgress,
    Container, Grid, IconButton, Input, InputAdornment,
    TextField, Tooltip, Typography, useMediaQuery
} from '@material-ui/core';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { MuiPickersUtilsProvider, KeyboardDatePicker } from '@material-ui/pickers';
import { TankMidnightService, CoreService } from "../../services";
import MaterialTable, { MTableToolbar } from 'material-table'
import TableIcons from '../../materialTableIcons';
import { ArrowExpandHorizontal, ArrowCollapseHorizontal, Magnify, Send, Check } from "mdi-material-ui";
import { makeStyles } from '@material-ui/core/styles';
import '../GridStyleOverrides/materialTableHome.css'
import allowAction from '../../helpers/allowAction';

const useStyles = makeStyles((theme) => ({
    textInput: {
        '& label.Mui-focused': {
            color: theme.palette.text.primary,
        },
        '& .MuiInput-underline:after': {
            borderBottomColor: 'green',
        },
        '& .MuiOutlinedInput-root': {
            '& fieldset': {
                borderColor: '#86C1D4',
            },
            '&:hover fieldset': {
                borderColor: theme.palette.text.primary,
            },
            '&.Mui-focused fieldset': {
                borderColor: theme.palette.text.primary,
            },
        },
    },
    pageTitleDiv: {
        marginTop: 20,
    },
    pageTitle: {
        paddingTop: 6,
        paddingBottom: 6,
        paddingLeft: 0,
        fontSize: 18,
        color: theme.palette.text.secondary,
        textTransform: 'uppercase'
    },
    cardFiltersContainer: {
        marginTop: 20,
        backgroundColor: theme.palette.background.paper
    },
    cardContentForFiltersContainer: {
        display: 'flex',
        flexDirection: 'row',
        flexWrap: 'nowrap',
        backgroundColor: theme.palette.background.paper,
        paddingRight: 50,
        paddingLeft: 50
    },
    filterDropdownsContainer: {
        minWidth: '80%',
    },
    gridItem: {
        display: 'flex',
        flexWrap: 'nowrap',
        flexDirection: 'row',
    },
    showAllAndFilterButtonsContainer: {
        display: 'flex',
        flexDirection: 'column',
        flexWrap: 'wrap',
        justifyContent: 'center',
        alignItems: 'center',
        marginLeft: 20,
    },
    showAllButton: {
        width: 140,
        marginBottom: 8,
    },
    filterButton: {
        width: 140,
        marginTop: 8,
    },
    outerGrid: {
        display: 'block',
        marginTop: 30,
        marginBottom: 30,
        padding: 16,
        boxShadow: '1px 2px 4px #888888',
        backgroundColor: theme.palette.background.paper,
        borderRadius: '4px',
    },
    inputGridContainer: {
        display: 'flex',
        flexDirection: 'row',
        width: '100%',
        marginBottom: 0,
        justifyContent: 'space-between'
    },
    exportButton: {
        width: 140,
        marginTop: 10,
        marginBottom: 10,
        marginLeft: 20
    },
    searchButton: {
        width: 180,
        fontWeight: 'bold',
        marginTop: 10,
        marginBottom: 10,
        marginLeft: 20
    },
    inputLabel: {
        marginTop: 'auto',
        marginBottom: 'auto',
        marginLeft: '1rem',
        marginRight: '2rem',
        color: theme.palette.text.secondary,
        width: '4rem',
        fontSize: 16,
        zIndex: 1000,
        lineHeight: 1.75,
        fontWeight: 'bold',
    },
    textField: {
        //width: 260,
        marginTop: 'auto',
        marginBottom: 'auto',
    },
    createNewButton: {
        margin: 20,
        padding: 8
    },
    tableHeader: {
        backgroundColor: '#86C1D4'
    },
    gridActionsContainer: {
        display: 'flex',
        width: '100%',
        height: 32,
        alignItems: 'center',
        justifyContent: 'flex-end',
        backgroundColor: theme.palette.background.paper,
        borderTopRightRadius: 4,
        borderTopLeftRadius: 4
    },
    tankMidnightTable: {
        display: 'flex',
        flexDirection: 'column',
        minWidth: 650,
        paddingLeft: 0,
        paddingRight: 0,
        marginTop: 20,
        '& .MuiDataGrid-colCellWrapper': {
            backgroundColor: '#86C1D4'
        },
        '& .MuiDataGrid-colCellTitle': {
            fontWeight: 700,
            color: theme.palette.background.paper,
            backgroundColor: '#86C1D4'
        },
        '& .MuiDataGrid-colCellSortable': {
            backgroundColor: '#86C1D4'
        },
        '& .MuiDataGrid-columnSeparator': {

        },
    },
    editIcon: {
        color: theme.palette.text.secondary
    },
    backdrop: {
        zIndex: theme.zIndex.drawer + 1,
    },
}));

//#region Material Table row/header/cell style default objs
const headerStyle = {
    backgroundColor: '#86C1D4',
    height: 49,
    textTransform: 'uppercase',
    color: 'white'
}
const rowStyle = {
    maxHeight: 50,
    paddingLeft: 30,
}
//#endregion

export default function TankMidnightHome() {

    //init Hooks
    const classes = useStyles();
    const dispatch = useDispatch();
    const dropdownItemsStore = useSelector((state) => state.dropdownMenuItems)
    // Loading/table visibility
    const [isLoading, setIsLoading] = useState(false);
    const [isTableLoading, setIsTableLoading] = useState(true);
    const [visibilityTable, setVisibilityTable] = useState("visible")
    const [savingOrSubmitting, setSavingOrSubmitting] = useState(false);

    //#region Handle expand/collapse grid
    const isLargeDisplay = useMediaQuery('(min-width: 1500px)');
    //use this to change container props. setting to {maxWidth: false} allows grid to expand full width
    const [containerProps, setContainerProps] = useState('');
    //Grid Actions toolip
    //...need these things to get better control of toolip or else it lingers on expand and collapse
    const [openTooltip, setOpenTooltip] = useState(false)
    const handleShowTooltip = () => {
        setOpenTooltip(true)
    }
    const handleHideTooltip = () => {
        setOpenTooltip(false)
    }
    //#endregion

    // Dialogs
    const [confirmDialog, setConfirmDialog] = useState({ isOpen: false, title: '', subTitle: '' })
    const [warnDialog, setWarnDialog] = useState({ isOpen: false, title: '', subTitle: '' })
    //Data
    const [dataForTable, setDataForTable] = useState([])
    const dataByDayStore = useSelector(state => state.tankMidnight.dataByDay)
    const [filterByMaterial, setFilterByMaterial] = useState(null)
    const [filterByTank, setFilterByTank] = useState(null)
    const [freeSearchValue, setFreeSearchValue] = useState('')

    const tableRef = useRef();
    /*return the start of the current date
         --- ex: Sun May 02 2021 00:00:00 GMT+0700 (Indochina Time)
         --- type: Date Object*/
    const today = startOfToday()
    const [queryDate, setQueryDate] = useState({ date: today });

    //APPLY FILTERS/SEARCH
    useEffect(() => {
        let data = [];
        if (dataByDayStore) {
            dataByDayStore.map((d) => {
                let found;
                try {
                    found = dropdownItemsStore['sapMaterial'].find(x => x.value === d.materialNo).text.split(':')[1].trimStart();
                } catch (e) {
                    console.log(e.message);
                    found = ''
                }
                data.push({ ...d, materialName: found })
            })
            if (freeSearchValue) {
                let query = freeSearchValue.toLowerCase().trim();
                let applySearch = data.filter((item) => {
                    return (
                        item.tank?.toLowerCase().indexOf(query) >= 0 ||
                        item.materialNo?.toLowerCase().indexOf(query) >= 0 ||
                        item.status?.toLowerCase().indexOf(query) >= 0 ||
                        item.tankStatus?.toLowerCase().indexOf(query) >= 0 ||
                        item.materialNo?.toLowerCase().indexOf(query) >= 0 ||
                        item.materialName?.toLowerCase().indexOf(query) >= 0
                    )
                })
                data = applySearch
            }
            if (filterByMaterial) {
                data = data.filter(x => x.materialNo === filterByMaterial.key)
            }
            if (filterByTank) {
                data = data.filter(x => x.tank === filterByTank.value)
            }
            setDataForTable([...data])
        }
    }, [dataByDayStore, freeSearchValue, filterByMaterial, filterByTank, dispatch, dropdownItemsStore['sapMaterial'], savingOrSubmitting])

    //GET DATA FOR SELECTED DATE -- DEFAULT CURRENT DATE
    useEffect(() => {
        async function getNewData() {
            let newData = await TankMidnightService.getTankMidnightByDate(queryDate);
            dispatch({
                type: SET_DATA_BY_DAY,
                payload: newData,
            });
            setIsTableLoading(false)
        }
        getNewData();
    }, [queryDate, dispatch])

    //Make sure sapMaterial data is in Redux store to get the material name to display in table
    useEffect(() => {
        /* Retreive dropdown if they are not already in the Redux store*/
        let dropdownToGet = ['sapPlant', 'operationTeam', 'status', 'vehicleType', 'sapStorageLocation', 'tank', 'unit', 'sapMaterial']
        if (dropdownItemsStore) {
            for (var i = 0; i < dropdownToGet.length; i++) {
                if (dropdownItemsStore[dropdownToGet[i]].length !== 0) {
                    dropdownToGet = dropdownToGet.filter(function (item) {
                        return item !== dropdownToGet[i];
                    })
                }
            }
        }
        CoreService.dropdownItems(dropdownToGet).then(
            (response) => {
                if (response) {
                    const data = response.data;
                    dispatch({
                        type: SET_DROPDOWN_MENU_ITEMS_LIST,
                        payload: data,
                    });
                }
                setIsLoading(false);
            });
    }, [dispatch]);

    async function submitToInternal(data) {
        try {
            setSavingOrSubmitting(true)
            let response = await TankMidnightService.submitTankData(data)
            dispatch({
                type: UPDATE_DATA_BY_DAY,
                payload: response,
            });
            setSavingOrSubmitting(false)
        } catch (e) {
            console.log(e)
            setSavingOrSubmitting(false)
        }
    }

    //#region PREPARE DATA FOR MATERIAL DROPDOWN
    //---filter duplicate materialNo values
    let uniqueMaterials = dataByDayStore?.filter((v, i, a) => a.findIndex(t => (t.materialNo === v.materialNo)) === i)
    //---init empty array
    let materialOptionsByDay = [];
    //---push objects with unique materialNos to empty array
    if (uniqueMaterials) {
        uniqueMaterials.forEach(x => {
            if (x.materialNo !== null) {
                let mat;
                try {
                    mat = dropdownItemsStore['sapMaterial'].find(y => y.value === x.materialNo).text;
                } catch (e) {
                    mat = ''
                }
                materialOptionsByDay.push({ key: x.materialNo, value: mat })
            }
        })
        materialOptionsByDay.sort((a, b) => (a.value > b.value) ? 1 : ((b.value > a.value) ? -1 : 0))
    }
    //#endregion

    //#region PREPARE DATA FOR TANK DROPDOWN
    //---filter duplicate tank values
    let uniqueTanks = dataByDayStore?.filter((v, i, a) => a.findIndex(t => (t.tank === v.tank)) === i)
    //---init empty array
    let tankOptionsByDay = [];
    //---push objects with unique materialNos to empty array
    if (uniqueTanks) {
        uniqueTanks.forEach(x => {
            tankOptionsByDay.push({ value: x.tank })
        })
        tankOptionsByDay.sort((a, b) => (a.value > b.value) ? 1 : ((b.value > a.value) ? -1 : 0))
    } 
    //#endregion

    //#region DATE/FILTER/SEARCH HANDLERS
    //sets the date field in queryValues to user-selected date
    const handleSearchDateChange = (date) => {
        setIsTableLoading(true)
        setQueryDate({ ...queryDate, date: date })
    };
    const handleMaterialFilterChange = (target, newFilter) => {
        setFilterByMaterial(newFilter)
        //object {key: materialNo, value: matNameMatNums[materialNo]}
    };
    const handleTankFilterChange = (target, newFilter) => {
        setFilterByTank(newFilter)
        //object { value: tank}
    };
    const handleFreeSearchChange = (event) => {
        setFreeSearchValue(event.target.value)
        //string
    };

    const handleExport = async () => {
        let tData = [...tableRef.current.dataManager?.data]
        if (tData.length === 0) {
            return alert("There is no data to export")
        }
        let res = await TankMidnightService.generateExcel(tData);
        console.log(res)
    }
    //#endregion

    //#region UPDATE ROW INLINE
    const handleOnRowUpdate = (rowData) => {

        if (!rowData.mt) {
            setWarnDialog({
                isOpen: true,
                title: 'Data Validation Error',
                subTitle: <><Box component="div">You must enter a value for MT</Box></>,
            })
            return;
        }
        if (rowData.liquidTemperature < -1000 || rowData.liquidTemperature > 1000) {
            setWarnDialog({
                isOpen: true,
                title: 'Data Validation Error',
                subTitle: <><Box component="div">TEMP must be between -1000 and 1000</Box></>,
            })
            return;
        }
        
        setSavingOrSubmitting(true)
        //dispatch UI user changes to update table
        dispatch({
            type: UPDATE_DATA_BY_DAY,
            payload: rowData,
        });
        TankMidnightService.updateTankData(rowData).then(
            (response) => {
                //dispatch update data from server with modBy field to show "Send" button
                dispatch({
                    type: UPDATE_DATA_BY_DAY,
                    payload: response,
                });
                setSavingOrSubmitting(false);
            });
        //refreshData();
    };
    //#endregion
    const columnDefs = [
        {
            field: "id",
            title: "ID",
            editable: 'never'
        },
        {
            field: "tank",
            title: "Tank",
            editable: 'never'
        },
        {
            title: "Submit",
            field: "submit",
            sorting: false,
            editable: 'never',
            cellStyle: {paddingTop: 4, paddingBottom: 4},
            render: (rowData) =>
                rowData && rowData.modBy && rowData.status === "INITIAL" ? (
                    <Button
                        color="primary"
                        variant='contained'
                        size='small'
                        style={{ width: 80, color: 'white', height: 32}}
                        startIcon={<Send style={{ fontSize: 12, color: 'white' }} />}
                        disabled={savingOrSubmitting}
                        onClick={() => submitToInternal(rowData)}
                    >
                        Send
                    </Button>
                )
                    :
                    rowData && rowData.modBy && rowData.status === "SUBMIT" ? (
                        <IconButton
                            disabled={true}
                            color="default"
                            onClick={() => console.log(rowData)}
                        >
                            <Check style={{ color: '#4ecc47' }} />
                        </IconButton>
                    )
                        :
                        ''
        },
        {
            field: "status",
            title: "Status",
            editable: 'never'
        },
        {
            field: "materialNo",
            title: "Material No.",
            editable: 'never'
        },
        {
            field: 'materialName',
            title: "Material Name",
            editable: 'never',
            sorting: true,
            cellStyle: {
                width: 120,
                minWidth: 120
            },
            //render: rowData => {
            //    let mat;
            //    try {
            //       mat = dropdownItemsStore['sapMaterial'].find(y => y.value === rowData.materialNo).text.split(':')[1].trimStart();
            //    } catch (e) {
            //        mat = "";
            //    }
            //    return mat;
            //}, 
        },
        {
            field: "tankLevel",
            title: "Level",
            editable: 'onUpdate',
            sorting: false,
            cellStyle: {
                width: 120,
                minWidth: 120
            },
            headerStyle: {
                width: 120,
                minWidth: 120
            },
            render: rowData => !rowData.tankLevel ? "" : Number(rowData.tankLevel).toLocaleString('en-US'),
            editComponent: props => (
                <Input
                    placeholder='Level'
                    size='small'
                    type="number"
                    value={props.value ? props.value : ''}
                    onKeyDown={(evt) => ["e", "E", "-", "+", "/", ",", "=", ";", ":", "'", '"', "`"].includes(evt.key) && evt.preventDefault()}
                    onChange={e => props.onChange(e.target.value)}
                    autoFocus={true}
                />
            )
        },
        {
            field: "liquidTemperature",
            title: "Temp",
            editable: 'onUpdate',
            sorting: false,
            cellStyle: {
                width: 120,
                minWidth: 120
            },
            headerStyle: {
                width: 120,
                minWidth: 120
            },
            render: rowData => !rowData.liquidTemperature ? "" : Number(rowData.liquidTemperature).toLocaleString('en-US'),
            editComponent: props => (
                <Input
                    placeholder='Temp'
                    size='small'
                    type="number"
                    value={props.value ? props.value : ''}
                    onKeyDown={(evt) => ["e", "E", "+", "/", ",", "=", ";", ":", "'", '"', "`"].includes(evt.key) && evt.preventDefault()}
                    onChange={e => props.onChange(e.target.value)}
                />
            )
        },
        {
            field: "density",
            title: "Density",
            editable: 'onUpdate',
            sorting: false,
            cellStyle: {
                width: 120,
                minWidth: 120
            },
            headerStyle: {
                width: 120,
                minWidth: 120
            },
            render: rowData => !rowData.density ? "" : Number(rowData.density).toLocaleString('en-US'),
            editComponent: props => (
                <Input
                    placeholder='Density'
                    type="number"
                    size='small'
                    value={props.value ? props.value : ''}
                    onKeyDown={(evt) => ["e", "E", "+", "/", ",", "=", ";", ":", "'", '"', "`"].includes(evt.key) && evt.preventDefault()}
                    onChange={e => props.onChange(e.target.value)}
                />
            )
        },
        {
            field: "mt",
            title: "MT",
            editable: 'onUpdate',
            sorting: false,
            cellStyle: {
                width: 120,
                minWidth: 120
            },
            headerStyle: {
                width: 120,
                minWidth: 120
            },
            render: rowData => !rowData.mt ? "" : Number(rowData.mt).toLocaleString('en-US'),
            editComponent: props => (
                <Input
                    placeholder='MT'
                    size='small'
                    type="number"
                    value={props.value ? props.value : ''}
                    onKeyDown={(evt) => ["e", "E", "-", "+", "/", ",", "=", ";", ":", "'", '"', "`"].includes(evt.key) && evt.preventDefault()}
                    onChange={e => props.onChange(e.target.value)}
                />
            )
        },
        {
            field: "lobs",
            title: 'Lobs',
            editable: 'onUpdate',
            sorting: false,
            cellStyle: {
                width: 120,
                minWidth: 120
            },
            headerStyle: {
                width: 120,
                minWidth: 120
            },
            render: rowData => !rowData.lobs ? "" : Number(rowData.lobs).toLocaleString('en-US'),
            editComponent: props => (
                <Input
                    placeholder='Lobs'
                    size='small'
                    type="number"
                    value={props.value ? props.value : ''}
                    onKeyDown={(evt) => ["e", "E", "-", "+", "/", ",", "=", ";", ":", "'", '"', "`"].includes(evt.key) && evt.preventDefault()}
                    onChange={e => props.onChange(e.target.value)}
                />
            )
        },
        {
            field: "kg",
            title: "KG",
            editable: 'never',
            sorting: false,
            cellStyle: {
                width: 120,
                minWidth: 120
            },
            headerStyle: {
                width: 120,
                minWidth: 120
            },
            render: rowData => !rowData.mt ? "" : Number(rowData.mt * 1000).toLocaleString('en-US')
        },
        {
            field: "modBy",
            title: "Update By",
            editable: 'never'
        },
        {
            field: "modDate",
            title: "Update Date",
            editable: 'never',
            render: rowData => {
                if (rowData && rowData.modDate) {
                    if (typeof rowData.modDate === 'string') {
                        return rowData.modDate
                    } else {
                        return rowData.modDate.toString()
                    }
                }
            }
        }
    ]

    return (
        <>
            <Container {...containerProps}>
                <div className={classes.pageTitleDiv}>
                    <h2 className={classes.pageTitle}>
                        Tank Midnight
                    </h2>
                </div>

                <Card className={classes.cardFiltersContainer}>
                    <CardContent className={classes.cardContentForFiltersContainer}>
                        <Grid container spacing={2} className={classes.filterDropdownsContainer} >

                            <Grid item xs={12} sm={4} md={6} lg={6} className={classes.gridItem}>
                                <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                    <KeyboardDatePicker
                                        disableToolbar
                                        autoOk={true}
                                        size="small"
                                        fullWidth
                                        disableFuture
                                        inputVariant="outlined"
                                        format="dd-MMM-yyyy"
                                        id="date"
                                        value={queryDate.date}
                                        onChange={handleSearchDateChange}
                                        KeyboardButtonProps={{
                                            'aria-label': 'change date',
                                        }}
                                    />
                                </MuiPickersUtilsProvider>
                            </Grid>

                            <Grid item xs={12} sm={4} md={6} lg={6} className={classes.gridItem}>
                                <Autocomplete
                                    disabled={dataByDayStore?.length === 0}
                                    id="material"
                                    name="material"
                                    fullWidth
                                    blurOnSelect={true}
                                    options={dataByDayStore?.length > 0 ? materialOptionsByDay : []}
                                    groupBy={(option) => option.firstLetter}
                                    getOptionLabel={(option) => option.value}
                                    renderOption={option => <>{option.value}</>}
                                    onChange={(event, newValue) => {
                                        handleMaterialFilterChange(event, newValue);
                                    }}
                                    renderInput={(params) => <TextField {...params}
                                        id="material"
                                        name="material"
                                        size="small"
                                        variant="outlined"
                                        label='Material'
                                    />}
                                />
                            </Grid>

                            <Grid item xs={12} sm={4} md={6} lg={6} className={classes.gridItem}>
                                <Autocomplete
                                    id="tank"
                                    name="tank"
                                    fullWidth
                                    blurOnSelect={true}
                                    disabled={dataByDayStore?.length === 0}
                                    options={dataByDayStore?.length > 0 ? tankOptionsByDay : []}
                                    getOptionLabel={(option) => option.value}
                                    renderOption={option => <>{option.value}</>}
                                    onChange={(event, newValue) => {
                                        handleTankFilterChange(event, newValue);
                                    }}
                                    renderInput={(params) => <TextField {...params}
                                        id="tankList"
                                        name="tankList"
                                        size="small"
                                        variant="outlined"
                                        label='Tank'
                                    />}
                                />
                            </Grid>

                            <Grid item xs={12} sm={4} md={6} lg={6} className={classes.gridItem}>
                                <TextField
                                    id="search"
                                    name="search"
                                    variant='outlined'
                                    size='small'
                                    fullWidth
                                    label='Type to filter results...'
                                    InputProps={{
                                        endAdornment:
                                            <InputAdornment position="end">
                                                <IconButton disabled={true}>
                                                    <Magnify />
                                                </IconButton>
                                            </InputAdornment>
                                    }}
                                    disabled={dataByDayStore?.length === 0}
                                    value={freeSearchValue}
                                    onChange={(event) => {
                                        handleFreeSearchChange(event);
                                    }}
                                />

                                <Button onClick={handleExport} size='small' color='primary' variant='contained' style={{ marginLeft: 10 }}>
                                    Export
                                    </Button>

                            </Grid>

                        </Grid>

                    </CardContent>
                </Card>
                <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                    {dataByDayStore && dataByDayStore?.length > 0 ?
                        <Box px={1.5} visibility={visibilityTable} className={classes.tankMidnightTable}>
                            {isLargeDisplay ?
                                <div className={classes.gridActionsContainer}>
                                    <Tooltip
                                        title={!containerProps ? 'Expand' : 'Collapse'}
                                        open={openTooltip}
                                        placement='top'
                                    >
                                        <IconButton
                                            onMouseEnter={handleShowTooltip}
                                            onMouseLeave={handleHideTooltip}
                                            onClick={() => {
                                                if (!containerProps) {
                                                    setContainerProps({ maxWidth: false })
                                                } else {
                                                    setContainerProps('')
                                                }
                                                handleHideTooltip()

                                            }
                                            }>
                                            {!containerProps ?
                                                <ArrowExpandHorizontal />
                                                :
                                                <ArrowCollapseHorizontal />
                                            }
                                        </IconButton>
                                    </Tooltip>
                                </div>
                                :
                                null}
                            <MaterialTable
                                style={{ width: '100%' }}
                                title=''
                                className={classes.matTable}
                                tableRef={tableRef}
                                data={dataForTable}
                                columns={columnDefs}
                                icons={TableIcons}
                                isLoading={isTableLoading || savingOrSubmitting}
                                editable={{
                                    isEditable: rowData => rowData.status !== 'SUBMIT' && allowAction("401", "update") === true,
                                    onRowUpdate: (newData, oldData) =>
                                        new Promise((resolve, reject) => {
                                            handleOnRowUpdate(newData);
                                            resolve();
                                        }),
                                }}
                                components={{
                                    Toolbar: props => (
                                        <div style={{ width: 0, height: 0 }}>
                                            <MTableToolbar {...props} />
                                        </div>
                                    ),
                                }}s
                                localization={{
                                    body: {
                                        emptyDataSourceMessage:
                                            <Typography variant='body2' style={{ margin: 'left', top: 80, position: 'absolute' }}>
                                                {freeSearchValue ? `No records matching ${freeSearchValue}`
                                                    :
                                                    !isTableLoading
                                                        ? `No records to display for ${format(queryDate.date, 'dd-MMM-yyyy')}`
                                                        :
                                                        null
                                                }
                                            </Typography>
                                    }
                                }}
                                options={{
                                    actionsCellStyle: { paddingLeft: 20, paddingRight: 20},
                                    actionsColumnIndex: 1,
                                    sorting: true,
                                    headerStyle: headerStyle,
                                    rowStyle: rowStyle,
                                    maxBodyHeight: '560px',
                                    showTitle: false,
                                    toolbar: false,
                                    paging: true,
                                    pageSize: 50,
                                    emptyRowsWhenPaging: true,
                                    pageSizeOptions: [10, 20, 50],
                                }} />
                        </Box>
                        : <></>}
                </Grid>
            </Container >

            <ConfirmDialog
                confirmDialog={confirmDialog}
                setConfirmDialog={setConfirmDialog}
            />
            <WarnDialog
                warnDialog={warnDialog}
                setWarnDialog={setWarnDialog}
            />
            <Backdrop className={classes.backdrop} open={isLoading || dataByDayStore?.length === 0}>
                <CircularProgress color="inherit" />
            </Backdrop>
        </>
    );
}
